module.exports = __webpack_public_path__ + "media/dorm_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/dorm_2000.jpg
// module id = 24
// module chunks = 0